import {
  nFormatter,
  createSeries,
  createSQL,
  seriesHead,
  appendAggregateValues,
  seriesDataItem,
  pickItem,
  resolve,
  getSeriesColors,
  extractColors,
  createFilter
} from "@/components/charts/common";
import pluralize from 'pluralize';



export default async function hydrator(parameters, data, chart) {

  let options = {};

  options.chart = {};
  options.chart.id = chart.id;
  options.dataLabels = {
    enabled: false
  };

  // chart.chartData.autoSelected = true;
  // Style
  chart.chartData.elevation = resolve("boxShadow.value", parameters);

  /**
  options.colors = ['#C1BEC7', '#FF0814', '#151821', '#857A89', '#F54355'];
  // options.colors = ['#FA8F13', '#EE2C1F', '#6A7785', '#283BD1', '#454E5D'];
  options.colors = ['#003f5c', '#58508d', '#bc5090', '#ff6361', '#ffa600'];
  // console.log("parameters.colorGradient", parameters.colorGradient);
  if (typeof parameters.colorGradient.item.id != "undefined" && parameters.colorGradient.item.id) {
    // options.colors = parameters.colorGradient.item.color.split(":");
  }**/
  options.yaxis = {
    labels: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      formatter: function(value) {
        if (isNaN(value)) {
          return value;
        }
        return nFormatter(value, 2);
      }
    }
  };

  options.xaxis = {
    labels: {
      show: true,
      offsetX: 0,
      offsetY: 0
    },
    axisBorder: {
      show: true,
      color: '#78909C',
      height: 1,
      width: '100%',
      offsetX: 0,
      offsetY: 0
    },
    axisTicks: {
      show: true,
      borderType: 'solid',
      color: '#78909C',
      height: 6,
      offsetX: 0,
      offsetY: 0
    }
  };

  const gridHeight = chart.grid.h;
  const layoutHeight = chart.grid.layout.rowHeight;
  const realHeight = (layoutHeight * gridHeight);
  data.height = realHeight;

  // console.log("layoutHeight", layoutHeight);
  // console.log("gridHeight", gridHeight);
  // console.log("realHeight", realHeight);
  // console.log("grid", chart.grid);
  /***
    options.legend = {};
    options.legend.show = false;

    options.xaxis = {};
    options.xaxis.labels = {};
    options.xaxis.labels.show = false;

    options.yaxis = {};
    options.yaxis.labels = {};
    options.yaxis.labels.show = false;

  **/

  // data.options = {...options};

  let chartDataSource = parameters.chartDataSource;

  let items = parameters.chartDataSource.items;

  for (let i = 0; i < items.length; i++) {
    await items[i].update(true);
    // console.log("chartDataSource", items[i]);
  }

  if (!chartDataSource.item.data.length && items.length) {
    chartDataSource.item = items[0];
    chartDataSource.value = items[0].id;
  }
  // console.log("chartDataSource.item.headers", chartDataSource.item.headers);
  chartDataSource.item.headers.forEach(function(t) {
    // console.log(t.text + " : " + t.type.type + " : " + t.type.points);
  });

  //  console.log("chartDataSource.item.fullQuery", chartDataSource.item.fullQuery);


  let query = {};
  let fullQuery = chartDataSource.item.fullQuery;
  query.id = chartDataSource.item.id;
  // "strftime('%Y %m', `date`)"

  let _group = resolve("groupData.value", parameters);

  let _item = resolve("itemData.value", parameters);

  let _transformItem = resolve("transformItemData.value", parameters);
  let _value = resolve("valueData.value", parameters);
  let _transformValue = resolve("transformValueData.value", parameters);

  const groupItem = pickItem(parameters.groupData);
  const itemItem = pickItem(parameters.itemData);
  const valueItem = pickItem(parameters.valueData);

  let _valueTitle = resolve("valueTitle.value", parameters);



  let metric = _value;

  _group = _group ? _group : null;
  _item = _item ? _item : _group;

  _group = _group ? _group : null;
  _item = _item ? _item : null;

  let oItem = _item;
  let oValue = _value;
  if (_item) {
    _item = _transformItem.replace("field", _item);
  }

  if (_value) {
    _value = _transformValue.replace("field", _value);
  }


  let customFilter = resolve("customFilter.value", parameters);


  // console.log("parameters", parameters);
  // console.log("_item", _item);
  // console.log("_value", _value)

  let _filters = resolve("tree.filters", chart);
  // console.log("tree filters", _filters);
  let filters = _filters ? Object.values(_filters) : [];

  query.sql = createSQL(fullQuery, _group, _item, _value, filters, _transformValue, customFilter);
  // alert(query.sql);
  // console.log(query.sql);

  let queryParameters = {
    id: chartDataSource.item.id,
    fullQuery: fullQuery,
    filters: filters,
    group: _group
  };
  //console.log("query", query);
  let dd = await chartDataSource.item.request(query);
  chart.response = dd;
  //console.log("table data size", dd.data.length);
  let series = createSeries(dd.data);

  let extractedColors = extractColors(resolve("colors.value", parameters));
  options.colors = getSeriesColors(extractedColors, series);

  const max = Math.max(...series.map(function(o) {
    return o.sum;
  }))
  series.forEach(function(row) {
    row.queryParameters = queryParameters;
    row.max = max;
    row.divPercentage = row.sum <= 0 ? 0 : (row.sum / max) * 100;
    row.divStyle = {
      backgroundColor: '#ccc',
      width: row.divPercentage + "%",
      height: "100%"
    }
    row.values = row.data.map(item => item.y ? item.y : 0);
  });
  //console.log("series size", series.length);
  // console.log("series data", series);
  // console.log("dd", dd);



  // console.log('max', max);

  // chart.chartData.headers = Object.keys(dd.data[0]);
  let headers = [];
  // console.log("groupItem", groupItem);
  headers.push({
    text: groupItem.text,
    value: 'name',
    align: 'left',
    type: 'text',
    class: "text-xs-left font-weight-bold",
    style: "width: 40%; padding: 0 0 0 24px; "
  });
  headers.push({
    text: _valueTitle ? _valueTitle : valueItem.text,
    value: 'sum',
    align: 'left',
    type: 'div-progress',
    class: "text-xs-left",
    style: "width: 60%; padding: 0 0 0 24px;"
  });
  // headers.push({ text: '', value: 'sum', align: 'right', type: 'sparkline', class:""});
  //const _headers = parameters.tableDataSource.item.headers;
  //  for(let i = 0; i < _headers.length; i++) {

  //  }

  function removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  let result = {};

  result.headers = headers;
  result.items = series;

  chart.activeItem = null;
  chart.dataSource = null;




  chart.loadActiveItem = async function(save) {
    // return;
    const item = chart.activeItem;

    chart.subHeaders.forEach((item, i) => {
      item.position = i;
    });
    const l = chart.subHeaders.length;
    parameters.selectedColumns.value = JSON.stringify(chart.subHeaders);
    // console.log("parameters.selectedColumns.value", parameters.selectedColumns.value);

    let fields = '';
    let group = '';
    for (let i = 0; i < l; i++) {
      const column = chart.subHeaders[i];
      if (column.selected != true) {
        continue;
      }

      let agg = typeof column.aggregate != "undefined" && column.aggregate && typeof column.aggregate.function != "undefined" ? column.aggregate : {function: "field"};
      // console.log("agg", agg);
      // console.log("column", column);
      let agg2 = agg.function.replace("field", column.value);

      if (agg2 != column.value) {
        fields += agg2 + " AS " + column.value + ",";
        group += typeof agg.aggregateFunction != "undefined" && agg.aggregateFunction == true ? "" : agg2 + ",";
      } else {
        fields += column.value + ",";
        group += column.value + ",";
      }
    }

    if (fields.slice("-1") == ",") {
      fields = fields.slice(0, -1);
    }

    if (group.slice("-1") == ",") {
      group = group.slice(0, -1);
    }

    let sql = "SELECT " + fields + " FROM (" + item.queryParameters.fullQuery + ") AS _subQuery ";
    let filters = [...item.queryParameters.filters];
    // filters.push()
    sql += "WHERE 1 = 1 ";
    filters.push({
      field: item.queryParameters.group,
      operator: '=',
      value: item.name
    });

    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i];
      sql += " AND " + filter.field + "" + filter.operator + "'" + filter.value + "' ";
    }

    sql += group ? "GROUP BY " + group : "";

    // console.log("calling sql " + sql);

    chart.dataSource = await chartDataSource.item.request({
      sql: sql,
      id: item.queryParameters.id
    });

    chart.response = chart.dataSource;
    // console.log(sql);
    // console.log(chart.dataSource);
  }
  chart.activeItems = [];
  chart.activeItems2 = [];
  chart.setActiveItem = async function(item) {

    chart.dataSource = null;
    chart.activeItem = {...item};
    chart.activeItems = [item];
    /**
    let sql = "SELECT * FROM (" + item.queryParameters.fullQuery + ") AS _subQuery ";
    let filters = [...item.queryParameters.filters];
    sql += "WHERE 1 = 1 ";
    filters.push({
      field: item.queryParameters.group,
      operator: '=',
      value: item.name
    });

    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i];
      sql += " AND " + filter.field + "" + filter.operator + "'" + filter.value + "' ";
    }

    sql = item.queryParameters.fullQuery + " LIMIT 1";

    filters = removeDuplicates(filters, 'field');
    const dataSource = await chartDataSource.item.request({
      sql: sql,
      id: item.queryParameters.id
    });
    chart.subHeaders = [];
    **/
  //  console.log("chartDataSource.headers", parameters.chartDataSource.item);
  //  console.log("dataSource.headers", dataSource.headers);
    // setHeaders(dataSource.headers);
    setHeaders(parameters.chartDataSource.item.headers);
  //  return;
    chart.loadActiveItem();
  }
  function setHeaders(fullHeaders) {
    // chart.subHeaders
    // console.log("1. parameters.selectedColumns.value", parameters.selectedColumns.value);
    let h = [];
    let subHeaders = [...fullHeaders];
    try {
       h = JSON.parse(parameters.selectedColumns.value);
    } catch(err) {

    }
    if(!Array.isArray(h)) {
      h = [];
    }
    //console.log("hello", h);
  //  subHeaders = [...fullHeaders];
    let r = [];

    for(let i = 0; i < subHeaders.length; i++) {
      let item = subHeaders[i];
    // subHeaders.forEach((item, i) => {
      item.menu = false;
      item.aggregate = null;
      item.position = i;
      if (typeof item.selected == "undefined") {
        item.selected = true;
      }

      const found = h.find(function(element) {return element.value == item.value;});

      item.selected = found && typeof found.selected != "undefined" ? found.selected : item.selected;
      item.aggregate = found && typeof found.aggregate != "undefined" ? found.aggregate : item.aggregate;

      if(found && typeof found.position != "undefined" && found.position != item.position) {
        // console.log("item position", item.value + ":" + item.position);
        // console.log("found position", item.value + ":" + found.position);
      }
      item.position = found && typeof found.position != "undefined" ? found.position : item.position;
      // console.log("item 2 position", item.value + ":" + item.position);
      if(found) {

      }

      subHeaders[i] = item;
      r.push({...item});

    }
    r = r.sort(function(a, b){ return a.position-b.position});
    r.forEach(it => {
      if(it.value == "year") {
        // console.log("year item", it);
      }
    })
    chart.subHeaders = [];
    chart.subHeaders = [...r];
    // console.log("sorted position subHeaders", r);
  }

  chart.chartData.series = [];
  chart.headers = headers;
  chart.chartData.series = series;
  chart.chartData.options = {
    chart: {
      enabled: true
    }
  };


  // console.log('chart', chart);
  // console.log("chart.chartData", chart.chartData)

}
